import { createSelector } from 'reselect';
import { RootState } from '../store.types';
import { ControlState } from './models';

const selectControlState = (state: RootState): ControlState => state.controls;

export const selectControls = createSelector(
  [selectControlState],
  (state: ControlState) => state ? state.controls : null
);

export const selectControlsLoading = createSelector(
  [selectControlState],
  (state: ControlState) => state ? state.loading : null
);

export const selectControlsloaded = createSelector(
  [selectControlState],
  (state: ControlState) => state ? state.loaded : null
);

export const selectControlsErrMsg = createSelector(
  [selectControlState],
  (state: ControlState) => state ? state.errMsg : null
);